import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmiodaron = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 17,
	viewBox: "0 0 19 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6895 1.66797L12.1406 9.0625H10.5996L13.8105 0.53125H14.7949L14.6895 1.66797ZM16.8223 9.0625L14.2676 1.66797L14.1562 0.53125H15.1465L18.3691 9.0625H16.8223ZM16.6992 5.89844V7.06445H12.0586V5.89844H16.6992Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 4.5625H3V14.5625",
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 13.0625H6L3 16.5625L0 13.0625Z",
			fill: "black"
		})
	]
});
export default SvgAmiodaron;
